import {mixedMeasure} from '../default/';

function _axis() {
  const that = this;
  const munged = this.__execs__.munged;
  const scale = this.__execs__.scale;
  const axisToggles = this.axis();
  const facet = this.facet();
  const dimensions = this.dimensions();
  const measures = this.measures();
  const grid = this.grid();
  const individualScale = this.isIndividualScale();
  const innerSize = this.innerSize();
  const aggregated = this.aggregated();
  const mixed = this.isMixed();
  const fieldObj = this.__execs__.field;
 
  let _axisScaleX = function (axisToggle) {
    if (mixed && !fieldObj.region) {
      axisToggle.field = measures.map(d => d.field).join('-');
    } else {
      axisToggle.field = fieldObj.x.field;
    }
    let curAxis = that.axisDefault(scale.x, axisToggle);
    if (scale.x.invert) curAxis.grid(grid).gridSize(innerSize.height);
    if (axisToggle.orient === 'bottom') curAxis.y(scale.y.range()[0]);
    return curAxis;
  }

  let _axisScaleY = function (axisToggle, scaleY = scale.y, field) {
    if (!field) {
      if (mixed) field = measures.map(d => d.field).join('-');
      else if (aggregated && measures[0].field === mixedMeasure.field) field = '';
      else field = measures[0].field;
    }
    axisToggle.field = field;
    let curAxis = that.axisDefault(scaleY, axisToggle);
    curAxis.grid(grid).gridSize(innerSize.width);
    if (axisToggle.orient === 'right') curAxis.x(scale.x.range()[1]);

    return curAxis;
  }

  let xAt = axisToggles.find( d => d.target === 'x');
  let yAt = axisToggles.find( d => d.target === 'y');
  if (this.isFacet()) { //TODO: facet 일 경우 공통요소
    //horizontal 일 경우 top d1
    //vertical 일 경우 right d1
    let field ;
    if (mixed) field = measures.map(d => d.field).join('-');
    else field = dimensions[1].field; 
    if (facet.orient === 'horizontal' && xAt) {
      xAt.field = field;
      xAt.orient = 'top';
      xAt.showDomain = false;
      this.axisDefault(scale.region, xAt);
    } else if (facet.orient === 'vertical' && yAt) {
      yAt.field = field;
      yAt.orient = 'right';
      yAt.showDomain = false;
      this.axisDefault(scale.region, yAt).x(innerSize.width);
    }
  } else {
    if (xAt) {
      _axisScaleX(xAt);
    } 
    if (yAt) { //TODO: 3개일때는 삭제 2개일때는 2개 그리기
      if (individualScale) {
        let ats = axisToggles.filter(d => d.target === 'y');
        if (munged.length <= 2) {
          ats.forEach((d,i) => _axisScaleY(d, munged[i].scale, munged[i].data.key));
        } 
      } else {
        _axisScaleY(yAt);
      }
    }
  }

  this.renderAxis();
}

export default _axis;


// WEBPACK FOOTER //
// ./layouts/line/_axis.js